
import { Auth } from 'aws-amplify'
import { DevicePromiseManager } from '../devicePromiseManager'
// const Logger = require("../logger")

class Customer {
	
	Register(username, password ) {
		const promise = new Promise((resolve, reject) => {
			Auth.signUp({ username, password })
			.then((data)=>{
				//needs the resolve so that it goes back to the one that called this properly
				resolve("success")
			})
			.catch( (err)=>{
				reject(err)
			})
		})
		return promise
	}

	Login(username, password) {
		const promise = new Promise((resolve, reject) => {
			Auth.signIn(username, password)
			.then((user)=>{
				//needs the resolve so that it goes back to the one that called this properly
				resolve("success")
			})
			.catch ( (err)=> {
				reject(err)
			})
		})
		return promise 
	}
	
	LoginOTP(username, otp) {
		const promise = new Promise((resolve, reject) => {
			Auth.signIn(username)
			.then((user)=>{
				if (user.challengeName === 'CUSTOM_CHALLENGE') {
					Auth.sendCustomChallengeAnswer(user, otp)
					.then((user)=>{
						// Successful login
						//needs the resolve so that it goes back to the one that called this properly
						resolve("success")
					})
					.catch((err)=> {
						if(err.message.toLowerCase()==="incorrect username or password.") {
							reject("Incorrect OTP")
						}else {
							reject(err.message)
						}
					})
				} else {
					// other situations, error?
					//return Auth.currentAuthenticatedUser()
				}
			})
			.catch ( (err)=> {
				if(err.message.toLowerCase()==="incorrect username or password.") {
					//Logger.log(err)
					reject("Incorrect OTP")
				}else {
					reject(err.message)
				}
			})
		})
		return promise 
	}
	
	//get current user details 
	GetCurrentUserDetails() {
		const promise = new Promise((resolve, reject) => {
			if(localStorage.getItem("customer")) {
				resolve(JSON.parse(localStorage.getItem("customer")))
			} else {
				DevicePromiseManager.call("getCurrentUser")
				.then((user)=>{
					const userInfo = {
						...user.attributes,
						username: user.username
					}
					localStorage.setItem('customer', JSON.stringify(userInfo))
					resolve(userInfo)
				})
				.catch ( (err)=> {
					reject(err)
				})
			}
		})
		return promise
	}
	
	
	ChangePassword(oldPass, newPass) {
		const promise = new Promise((resolve, reject) => {
			DevicePromiseManager.call("getCurrentUser")
			.then((user)=>{
				DevicePromiseManager.call("updatePassword", [user, oldPass, newPass])
				.then(()=>{
					resolve("success")
				}).catch((err)=>{
					reject(err.message)
					
				})
			})
			.catch ( (err)=> {
				reject(err)
			})
		})
		return promise
	}
	
	LogOut() {
		const promise = new Promise((resolve, reject) => {
			DevicePromiseManager.call("signOut")
			.then((data)=>{
				localStorage.removeItem('customer')

				// This was created in GetProfile()in the Profile class
				localStorage.removeItem("userExclusiveList");

				resolve(data)
			})
			.catch ( (err)=> {
				reject(err)
			})
		})
		return promise
	}
}


export default Customer



